import * as React from "react";
import type { SVGProps } from "react";
const SvgIconDocument = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.44.83q-.52.09-.98.38c-.21.14-.57.52-.7.75-.23.37-.32.65-.36 1.07-.03.37-.03 17.57 0 17.93.03.3.07.47.17.71.32.8 1.04 1.36 1.88 1.5.33.05 14.77.05 15.1 0 .84-.14 1.56-.7 1.88-1.5.1-.25.14-.4.17-.73.02-.2.02-2.42.02-7.1v-6.8l-.09-.17c-.07-.16-.2-.28-2.96-3.05C16.97 2.23 15.65.92 15.6.9c-.22-.11-.01-.1-5.65-.1C5.7.8 4.58.8 4.44.82m.16 1.72q-.33.13-.45.44c-.05.13-.05.18-.05 9 0 8.88 0 8.89.05 9.02q.1.26.35.4l.12.06h14.76l.12-.06q.24-.14.35-.4c.05-.13.05-.16.05-6.79V7.57l-2.53-2.53-2.53-2.52H9.76c-3.84 0-5.11.01-5.16.03m3.28 4.62c-.3.05-.58.3-.68.59-.05.14-.04.42.02.57.07.18.26.38.45.47l.14.07h3.6l.12-.06q.35-.16.48-.51c.03-.06.04-.19.04-.3 0-.15 0-.2-.07-.33q-.14-.29-.44-.43l-.15-.08h-1.7zm0 4.78c-.3.04-.58.3-.68.58-.05.15-.04.42.02.58.07.18.26.38.45.47l.14.06h8.38l.14-.06c.19-.1.38-.3.45-.47.08-.21.07-.47-.02-.66q-.14-.3-.44-.44l-.16-.07h-4.08zm0 4.78q-.42.08-.64.5c-.06.12-.07.17-.07.33q0 .54.48.78l.16.08h8.38l.16-.08q.47-.24.48-.78c0-.16-.01-.21-.07-.34q-.2-.4-.66-.5c-.19-.02-8.04-.02-8.22.01"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconDocument;
